var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRabbitmq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-169 285.9 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-109.242 311.496h-20.113a1.82 1.82 0 0 1-1.82-1.82v-20.963c0-1.56-1.253-2.812-2.812-2.812h-7.185c-1.56 0-2.812 1.253-2.812 2.812v20.822c0 1.087-.874 1.962-1.962 1.962l-6.594.024c-1.087 0-1.985-.874-1.962-1.962l.047-20.845c0-1.56-1.253-2.812-2.812-2.812h-7.185c-1.56 0-2.812 1.253-2.812 2.812v58.682c0 1.37 1.11 2.505 2.505 2.505h55.516c1.37 0 2.505-1.11 2.505-2.505V314a2.49 2.49 0 0 0-2.505-2.505zm-9.43 22.027a3.27 3.27 0 0 1-3.262 3.261h-5.672a3.27 3.27 0 0 1-3.261-3.261v-5.672a3.27 3.27 0 0 1 3.261-3.261h5.672a3.27 3.27 0 0 1 3.262 3.261z",
    fill: "#f60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRabbitmq);
export default __webpack_public_path__ + "static/media/rabbitmq.63ab94087152718024f51223a3ab7cc6.svg";
export { ForwardRef as ReactComponent };